import { SvgIcon, SvgIconProps } from '@mui/material';

const WifiOutlined = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="WifiOutlinedIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path d="M12.0007 13C10.1725 13 8.53524 13.8176 7.43473 15.1072L6.19753 13.4932C7.65526 11.9576 9.71613 11 12.0007 11C14.2831 11 16.3423 11.9558 17.7998 13.489L16.5628 15.1027C15.4623 13.8157 13.8267 13 12.0007 13Z" />
      <path d="M20.8648 9.49064L19.6414 11.0867C17.6625 9.17563 14.9689 7.99998 12.0007 7.99998C9.03034 7.99998 6.335 9.17727 4.35581 11.0907L3.13226 9.49456C5.45489 7.32666 8.57284 5.99998 12.0007 5.99998C15.4264 5.99998 18.5427 7.32506 20.8648 9.49064Z" />
      <path d="M23.9171 5.50899L22.6969 7.10065C19.8627 4.55132 16.1129 2.99999 12.0007 2.99999C7.88639 2.99999 4.13483 4.55288 1.30011 7.1045L0.0799561 5.51279C3.25485 2.70454 7.42869 1 12.0007 1C16.5706 1 20.7427 2.703 23.9171 5.50899Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0006 16C10.0676 16 8.50061 17.567 8.50061 19.5C8.50061 21.433 10.0676 23 12.0006 23C13.9336 23 15.5006 21.433 15.5006 19.5C15.5006 17.567 13.9336 16 12.0006 16ZM10.5006 19.5C10.5006 18.6716 11.1722 18 12.0006 18C12.829 18 13.5006 18.6716 13.5006 19.5C13.5006 20.3284 12.829 21 12.0006 21C11.1722 21 10.5006 20.3284 10.5006 19.5Z"
      />
    </SvgIcon>
  );
};

export default WifiOutlined;
